/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import MedicationIcon from 'icons/MedicationIcon';

const messages = defineMessages({
  title: {id: 'navigation.health-medication-log'},
});

const MedicationLogItem = () => (
  <RouteLinkItem
    iconBefore={MedicationIcon}
    route="midas/students/health/medication-log"
    title={messages.title}
  />
);

export default MedicationLogItem;
